import { render, staticRenderFns } from "./PoseCanvas.vue?vue&type=template&id=388dd9f3&scoped=true&"
import script from "./PoseCanvas.vue?vue&type=script&lang=js&"
export * from "./PoseCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388dd9f3",
  null
  
)

export default component.exports